import { Checkbox, dialog } from "../../../../nq-component";
import React, { useState } from "react";
import InputFactory from "../../../../components/InputFactory";
import { saveFileUseCase } from "../../../../usecases/file";
import { footer, html } from "framer-motion/client";
import DialogNote from "./DialogNote";

function OnBoardApplicantDetails({
  empDetails,
  clickReset,
  clickEdit,
  handleUpdate,
  onChangeData,
  handleSubmit,
  handleDeleteFile,
}) {
  function handleChange(value, field) {
    console.log("val", value, "field", field);
    onChangeData(value, field);
  }
  function submit() {
    const isComplete =
      empDetails?.docs1 &&
      empDetails?.docs2 &&
      empDetails?.docs3 &&
      empDetails?.docs4 &&
      empDetails?.docs5;

    isComplete
      ? handleSubmit()
      : dialog.fire({
          html: <DialogNote message="Please submit the required documents." />,
          footer: false,
        });
  }
  return (
    <div className="card mt-1 p-3 w-100 shadow-sm" style={{ fontSize: "12px" }}>
      <p className="mb-1">
        {console.log(empDetails)}
        <strong>Last Name:</strong> {empDetails?.lastName}
      </p>
      <p className="mb-1">
        <strong>First Name:</strong> {empDetails?.firstName}
      </p>
      <p className="mb-1">
        <strong>Position:</strong> {empDetails?.positionApplied}
      </p>

      {/* Buttons */}
      <div className="text-center mt-3">
        <button
          type="submit"
          className="btn text-white flex-grow-1"
          style={{ backgroundColor: "#e09552" }}
          onClick={() => submit()}
          disabled={empDetails.status === "Hired" ? true : false}
        >
          {empDetails?.status === "Hired" ? "Hired" : "Hire Applicant"}
        </button>
      </div>

      <div className="mt-3">
        <p className="fw-bold">Document Submitted</p>

        <div className="card mb-2 p-2 shadow-sm">
          <div className="d-flex align-items-center">
            <InputFactory
              type="Boolean"
              field="docs1"
              onChange={(value, field) => handleChange(value, field)}
              style={{
                color: "#e09552",
                backgroundColor: "#e09552",
              }}
              // defaultValue={empDetails?.docs1 || false}
              object={empDetails}
              required
            />
            <i
              className="bi bi-file-text fs-5  mx-2"
              style={{ color: "#e09552" }}
            ></i>
            <div className="flex-grow-1">
              <p className="mb-0 fw-semibold">
                Document1.pdf <span className="text-danger ms-1">*</span>
              </p>
            </div>
          </div>
        </div>

        <div className="card mb-2 p-2 shadow-sm">
          <div className="d-flex align-items-center">
            <InputFactory
              type="Boolean"
              field="docs2"
              onChange={(value, field) => handleChange(value, field)}
              style={{
                color: "#e09552",
                backgroundColor: "#e09552",
              }}
              // defaultValue={empDetails?.docs2 || false}
              object={empDetails}
              required
            />
            <i
              className="bi bi-file-text fs-5  mx-2"
              style={{ color: "#e09552" }}
            ></i>
            <div className="flex-grow-1">
              <p className="mb-0 fw-semibold">
                Document2.pdf<span className="text-danger ms-1">*</span>
              </p>
            </div>
          </div>
        </div>

        <div className="card mb-2 p-2 shadow-sm">
          <div className="d-flex align-items-center">
            <InputFactory
              type="Boolean"
              field="docs3"
              onChange={(value, field) => handleChange(value, field)}
              style={{
                color: "#e09552",
                backgroundColor: "#e09552",
              }}
              defaultValue={empDetails?.docs3 || false}
              object={empDetails}
              required
            />
            <i
              className="bi bi-file-text fs-5  mx-2"
              style={{ color: "#e09552" }}
            ></i>
            <div className="flex-grow-1">
              <p className="mb-0 fw-semibold">
                Document3.pdf<span className="text-danger ms-1">*</span>
              </p>
            </div>
          </div>
        </div>

        <div className="card mb-2 p-2 shadow-sm">
          <div className="d-flex align-items-center">
            <InputFactory
              type="Boolean"
              field="docs4"
              onChange={(value, field) => handleChange(value, field)}
              style={{
                color: "#e09552",
                backgroundColor: "#e09552",
              }}
              defaultValue={empDetails?.docs4 || false}
              object={empDetails}
              required
            />
            <i
              className="bi bi-file-text fs-5  mx-2"
              style={{ color: "#e09552" }}
            ></i>
            <div className="flex-grow-1">
              <p className="mb-0 fw-semibold">
                Document4.pdf<span className="text-danger ms-1">*</span>
              </p>
            </div>
          </div>
        </div>

        <div className="card mb-2 p-2 shadow-sm">
          <div className="d-flex align-items-center">
            <InputFactory
              type="Boolean"
              field="docs5"
              onChange={(value, field) => handleChange(value, field)}
              style={{
                color: "#e09552",
                backgroundColor: "#e09552",
              }}
              defaultValue={empDetails?.docs5 || false}
              object={empDetails}
              required
            />
            <i
              className="bi bi-file-text fs-5  mx-2"
              style={{ color: "#e09552" }}
            ></i>
            <div className="flex-grow-1">
              <p className="mb-0 fw-semibold">
                Document5.pdf<span className="text-danger ms-1">*</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="mb-3">
        <label className="form-label fw-bold">Remarks</label>
        <InputFactory
          className="col-9"
          type="String"
          _type="Text"
          field="onBoardRemarks"
          onChange={(value, field) => handleChange(value, field)}
          placeholder="Enter Remarks"
          object={empDetails}
          value={empDetails?.onBoardRemarks ?? ""}
        />
      </div>
      <div className="mb-3">
        <label className="form-label fw-bold">File Attachment</label>
        <InputFactory
          className="col-9"
          type="MultipleFile"
          field="attachment"
          saveFile={saveFileUseCase()}
          onChange={(value, field) => handleChange(value, field)}
          placeholder="Enter Reason"
          // required
          multi={true}
          multiple
        />

        {empDetails?.onBoardAttachment?.length > 0 && (
          <div className="mt-3">
            <h6>Uploaded Files:</h6>
            <ul className="list-unstyled">
              {empDetails?.onBoardAttachment?.map((fileURL, index) => {
                const fullFileName = fileURL.split("/").pop();

                // Split by "_" and get the last part
                const fileName = fullFileName.split("_").pop();

                return (
                  <li
                    key={index}
                    className="mb-2 d-flex align-items-center w-100"
                  >
                    <a
                      href={fileURL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-outline-primary d-flex align-items-center flex-grow-1 text-truncate"
                      style={{
                        textDecoration: "none",
                        padding: "8px",
                        borderRadius: "8px",
                        minWidth: "0", // Allow proper shrinking of buttons
                        marginRight: "0", // Remove right margin
                      }}
                    >
                      <i
                        className="bi bi-file-earmark-fill me-2"
                        style={{ color: "#D18237" }}
                      ></i>
                      <span className="text-truncate">
                        {fileName || `File ${index + 1}`}
                      </span>
                    </a>
                    {/* Delete button */}

                    <i
                      className="bi bi-trash text-danger ms-3"
                      onClick={() => handleDeleteFile(index)}
                    ></i>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
      <div className="text-center mt-3">
        <button
          className="btn text-white flex-grow-1"
          style={{ backgroundColor: "#387c36" }}
          onClick={() => handleUpdate()}
        >
          Update
        </button>
      </div>
    </div>
  );
}

export default OnBoardApplicantDetails;
